"use client";
import {usePathname, useRouter, useSearchParams} from "next/navigation";
import {useState} from "react";
import {Button} from "@/components/ui/button";
import {activityTypes} from "@/json/activityTypes";
import * as yup from "yup";
import {Form} from "@/components/ui/form";
import {CWFInput} from "@/components/ui/CWFInput";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import CWFButton from "@/components/ui/CWFButton";
import CWFSelect from "@/components/ui/CWFSelect";
import {activityFilters, locationFilters} from "@/lib/helpers/SearchStatus";

const formActivitySchema = yup.object({
    name : yup.string().nullable(),
    period: yup.string().nullable(),
    type: yup.number().nullable(),
});

export default function SearchActivity({isLoc = false}){
    const router = useRouter();

    const searchParams = useSearchParams();
    //const [searchParams, setSearchParams] = useState({});
    const pathname = usePathname();
    const {replace} = useRouter();

    const formActivity = useForm({
        resolver: yupResolver(formActivitySchema),
    });

    function searchActivity(data){
        const params = new URLSearchParams(searchParams);

        if(data.name !== undefined){
            params.set('name', data.name);
        }

        if(data.type !== undefined){
            params.set('type', data.type);
        }

        if(data.period !== undefined){
            params.set('period', data.period);
        }

        replace(`${pathname}?${params.toString()}`);
    }




    return(
        <Form {...formActivity}>
            <form className={"py-10 gap-x-4 gap-y-2 grid md:grid-cols-7"} onSubmit={formActivity.handleSubmit(searchActivity)}>
                <CWFInput
                    placeholder={isLoc ? "Nom de la location" : "Nom de l'activité"}
                    control={formActivity.control}
                    name={"name"}
                    className={"md:col-span-3"}
                />
                <CWFSelect
                    name={"type"}
                    className={"md:col-span-2"}
                    placeholder={isLoc ? "Type de location" : "Type d'activité"}
                    control={formActivity.control}
                    items={activityTypes}
                />
                <CWFSelect
                    name={"period"}
                    placeholder={"Filtrer"}
                    items={isLoc ? locationFilters : activityFilters}
                />
                <CWFButton>Rechercher</CWFButton>
            </form>
        </Form>
    )
}